<template>
  <div class="appContainer mail-box" v-if="isDisplayScoutMailPage">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('recruitment-letter-page.header', { split: '/' }) }}</h1>
    </div>

    <h3
      class="left-border"
      v-html="$t('recruitment-letter-page.title', { split: '<br>' })"
    ></h3>

    <div class="filter-widget mb-5 text-right">
      {{ $t('recruitment-letter-page.filter.title', { split: '/' }) }}:
      <div class="form-select ml-2">
        <select name="study_status" v-model="filter">
          <option disabled value="">
            --
            {{
              $t('register-page.step-two.choose', {
                split: '/'
              })
            }}
            --
          </option>
          <option
            v-bind:key="item.id"
            v-for="item in items"
            v-bind:value="item.value"
          >
            {{ $t(item.name, { split: '/' }) }}
          </option>
        </select>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="
        filterData !== null &&
        typeof filterData !== 'undefined' &&
        filterData.length !== 0
          ? filterData
          : []
      "
      :items-per-page="10"
      class="elevation-1 app_table"
    >
      <template v-slot:[`item.read_flag`]="{ item }">
        <v-icon
          v-if="item.read_flag == READ_FLAG_UN_READ"
          class="btn_item"
          color="#E8320D"
          >{{ emailIcon }}</v-icon
        >
        <v-icon v-else class="btn_item" color="#4B4948">{{
          emailOpenIcon
        }}</v-icon>
      </template>

      <template v-slot:[`item.time_display`]="{ item }">
        <span @click="handleShowDetail(item)">
          {{ convertDateAndTime(item.time_display) }}
        </span>
      </template>

      <template v-slot:[`item.company_name`]="{ item }">
        <router-link
          :to="'list-company' + '/' + item.exhibiting_company_id + '/detail'"
          ><span @click="handleShowDetail(item)">{{ item.company_name }}</span>
        </router-link>
      </template>

      <template v-slot:[`item.industry_type_name`]="{ item }">
        {{ item.industry_type_name }}
      </template>
      <template v-slot:[`item.work_location_name`]="{ item }">
        {{ item.work_location_name }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="60vw">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog">{{
          closeIcon
        }}</v-icon>
        <div class="dialog">
          <table class="table-detail-info">
            <tr>
              <td class="td-left">
                {{
                  $t('recruitment-letter-page.dialog.title', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                {{ itemDetail !== null && itemDetail.title }}
              </td>
            </tr>
            <tr>
              <td class="td-left">
                {{
                  $t('recruitment-letter-page.dialog.content', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                <div class="textarea-field">
                  <span v-html="itemDetail !== null && itemDetail.body"></span>
                </div>
              </td>
            </tr>
          </table>

          <v-card-actions>
            <v-btn
              class="btn-logout mt-2"
              depressed
              color="#e8320e"
              @click="handleCloseDialog"
            >
              {{ $t('component.btn-close', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <ScrollTopBtn />
  </div>
</template>

<script>
import '@/style/common.scss';
import { mdiEmailOpen, mdiEmail, mdiClose } from '@mdi/js';
import { mapGetters } from 'vuex';
import {
  READ_FLAG_READ,
  READ_FLAG_UN_READ,
  FILTERED_BY_NEW,
  FILTERED_BY_VIEWED
} from '@/common/constants';
import ScrollTopBtn from '@/components/ScrollTopBtn';
import './mailbox.scss';
export default {
  components: {
    ScrollTopBtn
  },
  data() {
    return {
      emailOpenIcon: mdiEmailOpen,
      emailIcon: mdiEmail,
      closeIcon: mdiClose,
      checkbox: '',
      headers: [
        { text: '', value: 'read_flag' },
        {
          text: this.$t('recruitment-letter-page.table-header.received-date', {
            split: '/'
          }),
          sortable: false,
          align: 'start',
          value: 'time_display'
        },

        {
          text: this.$t('recruitment-letter-page.table-header.company-name', {
            split: '/'
          }),
          value: 'company_name'
        },

        {
          text: this.$t('recruitment-letter-page.table-header.position', {
            split: '/'
          }),
          value: 'industry_type_name'
        },
        {
          text: this.$t('recruitment-letter-page.table-header.work-location', {
            split: '/'
          }),
          value: 'work_location_name'
        }
      ],

      items: [
        {
          name: 'recruitment-letter-page.filter.by-new',
          value: FILTERED_BY_NEW
        },
        {
          name: 'recruitment-letter-page.filter.by-viewed',
          value: FILTERED_BY_VIEWED
        }
      ],

      filter: FILTERED_BY_NEW,
      filterData: [],
      dialog: false,
      itemDetail: null
    };
  },

  methods: {
    industryTypeFormat: function (id) {
      const arr = this.m_industry_type.filter((ele) => ele.id === id);

      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workLocationFormat: function (workLocationArr = '[]') {
      let stringWorkLocation = '';

      const workLocation = this.m_work_location_company;

      const workLocationId =
        workLocationArr !== null && workLocationArr !== ''
          ? JSON.parse(workLocationArr)
          : null;

      if (workLocationId !== null) {
        workLocation.map((ele) => {
          workLocationId.forEach((item, index) => {
            if (item == ele.id) {
              stringWorkLocation += ele.name_convert;
              stringWorkLocation +=
                index < workLocationId.length - 1 ? ', ' : '';
            }
          });
        });
      }

      return stringWorkLocation;
    },

    filteredData() {
      if (this.profile !== null) {
        const data = this.profile.scout_mail;

        data.map((item) => {
          item.industry_type_name = this.industryTypeFormat(item.industry_type);
          item.work_location_name = this.workLocationFormat(item.work_location);
        });

        if (this.filter == FILTERED_BY_NEW) {
          data.sort((mail, otherMail) => {
            const mailA = mail.time_display;
            const mailB = otherMail.time_display;

            return new Date(mailB) - new Date(mailA);
          });
        }
        if (this.filter == FILTERED_BY_VIEWED) {
          data.sort((mail, otherMail) => {
            const mailA = mail.read_flag;
            const mailB = otherMail.read_flag;

            if (mailA < mailB) {
              return 1;
            }
            if (mailA > mailB) {
              return -1;
            }
            return 0;
          });
        }

        return (this.filterData = Object.assign([], data));
      }
    },

    handleShowDetail(item) {
      this.itemDetail = Object.assign({}, item);
      this.dialog = true;
      const scout_mail_id = item.id;

      this.$store.dispatch('updateScoutMailWhenViewed', {
        scout_mail_id: scout_mail_id
      });
    },

    handleCloseDialog() {
      this.dialog = false;
    }
  },

  created() {
    if (!this.isDisplayScoutMailPage) {
      this.$router.push({ name: 'top-applicant' });
    }

    this.READ_FLAG_READ = READ_FLAG_READ;
    this.READ_FLAG_UN_READ = READ_FLAG_UN_READ;

    this.filteredData();
  },

  mounted() {
    if (this.$route.query) {
      const { noti } = this.$route.query;

      if (noti) {
        const itemArray = this.filterData.filter((ele) => ele.id === noti);

        if (itemArray.length > 0) {
          this.handleShowDetail(itemArray[0]);
        }
      }
    }
  },

  watch: {
    '$route.query': function (val = '') {
      if (val) {
        const { noti } = val;

        if (noti) {
          const itemArray = this.filterData.filter((ele) => ele.id === noti);

          if (itemArray.length > 0) {
            this.handleShowDetail(itemArray[0]);
          }
        }
      }
    },
    m_industry_type: function (val) {
      return val;
    },
    m_work_location_company: function (val) {
      return val;
    },

    m_work_location_company: function (val) {
      return val;
    },

    filterData: function (val) {
      return Object.assign([], val);
    },

    '$i18n.locale': function () {
      this.filteredData();
      this.headers = [
        { text: '', value: 'read_flag' },
        {
          text: this.$t('recruitment-letter-page.table-header.received-date', {
            split: '/'
          }),
          sortable: false,
          align: 'start',
          value: 'time_display'
        },

        {
          text: this.$t('recruitment-letter-page.table-header.company-name', {
            split: '/'
          }),
          value: 'company_name'
        },

        {
          text: this.$t('recruitment-letter-page.table-header.position', {
            split: '/'
          }),
          value: 'industry_type_name'
        },
        {
          text: this.$t('recruitment-letter-page.table-header.work-location', {
            split: '/'
          }),
          value: 'work_location_name'
        }
      ];
    },

    profile: function (val) {
      if (val !== null) {
        const data = val.scout_mail;

        data.map((item) => {
          item.industry_type_name = this.industryTypeFormat(item.industry_type);
          item.work_location_name = this.workLocationFormat(item.work_location);
        });

        if (this.filter == FILTERED_BY_NEW) {
          data.sort((mail, otherMail) => {
            const mailA = mail.time_display;
            const mailB = otherMail.time_display;
            return new Date(mailB) - new Date(mailA);
          });
        }
        this.filterData = data;
        return val;
      }
    },

    filter: function () {
      this.filteredData();
    }
  },

  computed: {
    ...mapGetters({
      profile: 'getProfile',

      scoutMail: 'getScoutMail'
    })
  }
};
</script>
